import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type EditAddFileIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const EditAddFileIllustration = ({ ...props }: EditAddFileIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeMiterlimit="10" fill="none">
      <path d="M40 2v12h12" />
      <path d="M52 30V14L40 2H4v60h48V48" />
      <path d="M43 49l-6 1 1-6 18-18 5 5z" strokeLinecap="square" />
      <path d="M27.6 22.6v16" strokeLinecap="square" />
      <path d="M35.6 30.6h-16" strokeLinecap="square" />
    </g>
  </BaseIllustration>
);

EditAddFileIllustration.displayName = 'EditAddFileIllustration';
